module.exports = __webpack_public_path__ + "img/Map.3f012b8c.png";